/* globals jQuery, configurations */
(function ($, configurations) {

    'use strict';

    /**
     * Sets default validator values.
     */
    $.validator.setDefaults({
        ignoreTitle: true,
        focusCleanup: true,
        focusInvalid: false,
        debug: false,
        errorClass: 'error-hlp',
        errorElement: 'div',
        onfocusin: function (element) {
            this.lastActive = element;
            if (this.settings.focusCleanup && !this.blockFocusCleanup) {
                this.errorsFor(element).fadeOut(
                    200, function () {
                        $(element).parent().removeClass('frm-error');
                    }
                );
            }
        },
        highlight: function (element) {
            var $fieldset = $(element).parents('fieldset');
            $fieldset.removeClass('frm-error-ok');
            $fieldset.addClass('frm-error');
        },
        unhighlight: function (element) {
            var $fieldset = $(element).parents('fieldset');
            $fieldset.removeClass('frm-error');
            $fieldset.addClass('frm-error-ok');
        },
        errorPlacement: function (error, element) {
            var $fieldset = element.closest('fieldset');
            if ($fieldset.length !== 0) {
                error.appendTo($fieldset);
            } else {
                error.insertAfter(element);
            }
        }
    });

    /**
     * Modifies default validator messages.
     */
    $.extend($.validator.messages, {
        required: configurations.labels.FORM_ERROR_required,
        remote: 'Please fix this field.', // Please fix this field.
        email: configurations.labels.FORM_ERROR_email, // Please enter a valid email address.
        url: configurations.labels.FORM_ERROR_url, // Please enter a valid URL.
        date: 'Please enter a valid date', // Please enter a valid date.
        dateISO: 'Please enter a valid date (ISO).', // Please enter a valid date (ISO).
        number: configurations.labels.FORM_ERROR_number, // Please enter a valid number.
        digits: configurations.labels.FORM_ERROR_digits, // Please enter only digits.
        creditcard: 'Please enter a valid credit card number.', // Please enter a valid credit card number.
        equalTo: configurations.labels.FORM_ERROR_equalto, // Please enter the same value again.
        accept: 'Please enter a value with a valid extension.', // Please enter a value with a valid extension.
        maxlength: $.validator.format(configurations.labels.FORM_ERROR_maxlength), // Please enter no more than {0} characters.
        minlength: $.validator.format(configurations.labels.FORM_ERROR_minlength), // Please enter at least {0} characters.
        rangelength: $.validator.format(configurations.labels.FORM_ERROR_rangelength), // Please enter a value between {0} and {1} characters long.
        range: $.validator.format(configurations.labels.FORM_ERROR_range), // Please enter a value between {0} and {1}.
        max: $.validator.format(configurations.labels.FORM_ERROR_max), // Please enter a value less than or equal to {0}.
        min: $.validator.format(configurations.labels.FORM_ERROR_min), // Please enter a value greater than or equal to {0}.
        lettersonly: 'Please use only letters.'
    });

    /**
     * -------------------------------
     * Validation method definition.
     * -------------------------------
     */
    $.validator.addMethod('isValidTitle', function (value) {
        var expression = /[a-z0-9]/i;
        return expression.test(value);
    }, configurations.labels.COMMUNITY_thread_title_error_lbl);

    /**
     * -------------------------------
     * Validation method definition.
     * -------------------------------
     */
    $.validator.addMethod('isValidCompanyName', function (value) {
        var expression = /[a-z0-9]/i;
        return expression.test(value);
    }, configurations.labels.COMMON_incorrect_company_name_lbl);

    /**
     * -------------------------------
     * Validation method definition.
     * -------------------------------
     */
    $.validator.addMethod('isValidEmailAddress', function (value) {
        var emailRegex = new RegExp(configurations.constants.emailRegex,'i');
        return emailRegex.test(value);
    }, configurations.labels.COMMON_mail_KO_lbl);

    /**
     * -------------------------------
     * Validation nickname
     * -------------------------------
     */
    $.validator.addMethod('isNickNameValid', function (value) {
        var reg = new RegExp('^[a-zA-Z_][a-zA-Z0-9_]*$', 'i');
        return reg.test(value);
    }, configurations.labels.VALIDATION_nickname_format_txt);

    /**
     * Validate that phone field is valid.
     */
    $.validator.addMethod('phoneformat', function (sPhone, element) {
        var validPhoneChars = configurations.project.phoneValidChars,
            phonePrefix = configurations.project.phonePrefix,
            minPhoneChars = configurations.project.phoneMinLength,
            maxPhoneChars = configurations.project.phoneMaxLength,
            sRegularMatch = new RegExp('^[0-9]*$'),
            keyChar, keyPrefix;

        // If it is informed then the format must be valid.
        if (sPhone === '') {
            return true;
        }

        sPhone = sPhone + '';

        keyChar = -1;
        for (keyChar in validPhoneChars) {
            while (sPhone.indexOf(validPhoneChars[keyChar]) !== -1) {
                sPhone = sPhone.replace(validPhoneChars[keyChar], '');
            }
        }

        keyPrefix = -1;
        for (keyPrefix in phonePrefix) {
            if (sPhone.indexOf(phonePrefix[keyPrefix]) === 0) {
                sPhone = sPhone.replace(phonePrefix[keyPrefix], '');
            }
        }
        if (!sRegularMatch.test(sPhone)) {
            return false;
        }

        if (sPhone.length < minPhoneChars || sPhone.length > maxPhoneChars) {
            return false;
        }

        return true;
    }, configurations.labels.FORM_ERROR_phoneformat);

    $.validator.addMethod('postalformat', function (sPostal, element) {
        var validPostalChars = configurations.project.phoneValidChars,
            keyChar,
            currencySymbol = configurations.project.currencySymbol,
            minPostalLength = configurations.project.postalCodeMinLength,
            maxPostalLength = configurations.project.postalCodeMaxLength,
            sRegularMatch = new RegExp('^[0-9]*$');

        // In some countries the postal code is not required, but if it is informed
        // then the format must be valid.
        if (sPostal === '') {
            return true;
        }

        for (keyChar in validPostalChars) {
            while (sPostal.indexOf(validPostalChars[keyChar]) !== -1) {
                sPostal = sPostal.replace(validPostalChars[keyChar], '');
            }
        }

        if (currencySymbol === 'GBP') {
            sRegularMatch = new RegExp('^[a-zA-Z0-9]*$');
        }

        if (!sRegularMatch.test(sPostal)) {
            return false;
        }

        if (sPostal.length < minPostalLength || sPostal.length > maxPostalLength) {
            return false;
        }

        return true;
    }, configurations.labels.FORM_ERROR_postalformat);

    /**
     * Validates autocomplete input.
     * To use this method use 'autocomplete: true'.
     * The method name is 'autocompletevalid' because 'autocomplete' matches
     * with the HTML attribute and tries to validate as autocomplete field
     * those inputs with attribute "autocomplete='off'".
     * selectedValue, is an own defined field inside data to allow deleting and
     * selecting new values.
     *
     * @since  Sprint 2013.05 (IET-5240)
     */
    $.validator.addMethod('autocompletevalid', function (value, element) {
        var autocomplete = $(element).data('ui-autocomplete') || {},
            selectedValue = $(element).data('selectedvalue') || null;

        if (value === selectedValue) {
            return true;
        }

        if (autocomplete.selectedItem == null || autocomplete.selectedItem === undefined) {
            return false;
        }

        $(element).data('selectedvalue', autocomplete.selectedItem.value);
        return true;
    }, configurations.labels.FORM_ERROR_use_autocomplete);

    /**
     * This rule checks the string against a regexp.
     * Use: regexp: /reg exp/
     */
    $.validator.addMethod('regexp', function (value, element, regexp) {
        return value.match(regexp);
    });

    $.validator.addMethod('selectcheck', function (value, element) {

        return (value !== '0' && value !== '-1');
    }, configurations.labels.FORM_ERROR_required);

    $.validator.addMethod('minwords', function (value, element, minimum) {
        var wordsNumber = 0;

        // exclude start and end white-space
        value = value.replace(/(^\s*)|(\s*$)/gi, '');
        // convert 2 or more space to 1
        value = value.replace(/[ ]{2,}/gi, ' ');
        // exclude newline with a start spacing
        value = value.replace(/\n /, '\n');

        wordsNumber = value.split(' ').length;

        return wordsNumber >= minimum;

    }, configurations.labels.MENU_company_description_min_characters_lbl);

    $.validator.addMethod('lessThanOrEqual', function (value, element, params) {
        var maxValue = typeof params[0] === 'string'
            ? parseInt($(params[0]).val())
            : params[0];

        if (isNaN(maxValue)) {
            return true;
        }

        return parseInt(value) <= maxValue;

    }, $.validator.format('Please enter a number smaller or equals to {0}'));

    $.validator.addMethod('greaterThanOrEqual', function (value, element, params) {
        var minValue = typeof params[0] === 'string'
            ? parseInt($(params[0]).val())
            : params[0];

        if (isNaN(minValue)) {
            return true;
        }

        return parseInt(value) >= minValue;

    }, $.validator.format('Please enter a number greater or equals to {0}'));

    /**
     * This function checks the format of Fiscal Identifer Number by locale.
     */
    $.validator.addMethod('FINformat', function (sFIN, element) {
        var validFINExp = configurations.project.fiscalIdNumber,
            sRegularMatch = new RegExp('^' + validFINExp + '$');

        return sRegularMatch.test(sFIN);

    }, jQuery.validator.format('El Número Fiscal no es valido'));

    /**
     * -------------------------------------------------------------------------------------------
     *
     * Remote method extended to add the ability of delay the remote call after each keyup.
     *
     * To use it, just add the delay property on the options object passed to the remote method.
     * Delay time in miliseconds.
     *
     * Use:
     *  field_to_be_checked: {
                    required: true,
                    remote: {
                        delay: 200,
                        url: '/front/user_account/check_existing_email'
                    }
                },
     *
     */
    $.validator.remoteTimer = {};
    $.validator.methods._remote = $.validator.methods.remote;
    $.validator.methods.remote = function remote(value, element, param) {
        var delay,
            elemId,
            args = arguments;

        if (typeof param.delay === 'undefined') {
            return $.validator.methods._remote.apply(this, args);
        }

        delay = parseInt(param.delay);
        elemId = $(element).attr('name');

        clearTimeout($.validator.remoteTimer[elemId]);

        $.validator.remoteTimer[elemId] = setTimeout(function () {
            $.validator.methods._remote.apply(this, args);
        }.bind(this), delay);

        return 'pending';
    };
    /**
     * -------------------------------------------------------------------------------------------
     */

}(jQuery, window.configurations));
